export const USERNAME = "username"
export const PASSWORD = "password"
